var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pravo__top"},[_c('div',{staticClass:"pravo__top__nadpis"},[_c('div',{staticClass:"pravo__top__nadpis__image"},[_c('div',{class:_vm.Image})]),_c('div',{staticClass:"pravo__top__nadpis__text"},[_vm._v(_vm._s(_vm.Header))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }